import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import Moment from 'moment'
import './events/global.event.bus'
import "@/filters"
import i18n from '@/locale/i18n' // 🆕 i18n faylni shu yerdan import qilamiz

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(VueAxios, axios)

new Vue({
  vuetify,
  router,
  store,
  i18n, // 🆕 i18n ni Vue instance ichiga qo‘shamiz
  render: h => h(App),
  created() {
    Moment.locale('ru')
  }
}).$mount('#app')
